export default __webpack_public_path__ + "static/media/css.36b2d80f.png";